import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ReplaySubject, Subscription, takeUntil } from 'rxjs';
import { MultiLanguageService } from '../../core/multi-language/multi-language.service';
import { MICROSERVICES } from '../../constants/web-services';
import { MASTERSSERVICES } from '../../constants/master-service';
import { AppBaseService } from '../../services/http.service';

@Component({
  selector: 'lib-cash-counter-dialog',
  templateUrl: './cash-counter-dialog.component.html',
  styleUrl: './cash-counter-dialog.component.css'
})
export class CashCounterDialogComponent implements OnInit, OnDestroy{
   private unsubscribe: ReplaySubject<boolean> = new ReplaySubject(1);
    cashCounterList: any[];
    filterCashCounter: any[];
    cashCounter: any;
    cashCounterSearch: FormControl = new FormControl();
    private subscriptionList = new Subscription();
    cashCounterName: string = "";


   constructor(
     public dialogRef: MatDialogRef<CashCounterDialogComponent>,
     public snackBar: MatSnackBar,
     @Inject(MAT_DIALOG_DATA) public data,
     private langService: MultiLanguageService,
     public baseservice: AppBaseService,
    ) { }
  
    ngOnInit() {
      this.cashCounterList = this.data.cashCounter;
      this.filterCashCounter = this.cashCounterList;
      this.cashCounter = this.data.setDefaultCashCounter;
      this.cashCounterName = this.cashCounter.cashCounterDesc;
    
      const index = this.cashCounterList.findIndex(
        (item) => item.cashCounterId === this.cashCounter.cashCounterId
      );

     if (index !== -1) {
      this.cashCounterList.splice(index, 1); // Removes the item
     }
      this.onChanges();
    }
  
    ngOnDestroy() {
      this.unsubscribe.next(true);
      this.unsubscribe.complete();
    }
  
    onNoClick(): void {
      this.dialogRef.close();
    }

  onChanges() {
    this.subscriptionList.add(
      this.cashCounterSearch.valueChanges.subscribe((value) => {
        this.filterCashCounter = this.cashCounterList.filter((i) =>
          i.cashCounterDesc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
  }

  updateCashCounter(){
    if (this.cashCounter && this.cashCounter.cashCounterId) {
    let payload = {
      loggedCashCounterId: localStorage.getItem("counterId") ? localStorage.getItem("counterId") : null,
      selectedCashCounterId: this.cashCounter.cashCounterId,
      location: ""
    }
    this.baseservice.setResourceURL(MICROSERVICES.IDENTITY_SERVICE);
      this.baseservice
        .putResource(
          MASTERSSERVICES.UPDATE_CASH_COUNTER ,payload
        )
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((data) => {
          if(data){
            this.dialogRef.close(data);
          }
      });
    }
  }

  releaseCashcounter(){
    let userId = localStorage.getItem("userId") ? atob(localStorage.getItem("userId")) : "";
    if(userId){
    this.baseservice.setResourceURL(MICROSERVICES.IDENTITY_SERVICE);
      this.baseservice
        .putResource(
          MASTERSSERVICES.UPDATE_CASH_COUNTER_STATUS +  userId ,{}
        )
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((data) => { 
          if(data){
            this.dialogRef.close(data);
          }
      });
    }
  }

}
